import { ArticleView, searchArticles } from "@serophin/nottldr-shared";
import { ScrollToTop } from "../../components/ScrollToTop";
import type { PageProps } from "../pageProps";
import { Authors } from "./landing/Authors";
import { Closing } from "./landing/Closing";
import { Header } from "./landing/Header";
import { Hero } from "./landing/Hero";
import { Inside } from "./landing/Inside";
import { Levels } from "./landing/Levels";
import { Moments } from "./landing/Moments";
import { Perks } from "./landing/Perks";
import { Popular } from "./landing/Popular";
import { Topics } from "./landing/Topics";
import { LANDING_ARTICLES, LANDING_TOPICS } from "./landingTopics";
import { type LandingSeed, SEED } from "./seedTypes";
import { useRemote } from "./useRemote";
import { useSeed } from "./useSeed";

const EMPTY_LANDING: LandingSeed = { metas: [], authors: {}, nextCursor: null, subcategories: LANDING_TOPICS };

/** Reached by navigation there is no prerendered data, so the popular articles come from the API. */
const fetchLanding = async (): Promise<LandingSeed> => {
  const page = await searchArticles({ view: ArticleView.POPULAR, limit: LANDING_ARTICLES });
  return { metas: page.metas, authors: page.authors, nextCursor: page.nextCursor, subcategories: LANDING_TOPICS };
};

/** `/` for a visitor without a session: what !tldr is for, written for the person reading it. */
export const LandingPage = (_props: PageProps) => {
  const landing = useRemote(useSeed<LandingSeed>(SEED.landing), "landing", fetchLanding);
  const { metas, authors, subcategories } = landing.status === "ready" ? landing.data : EMPTY_LANDING;

  return (
    <main class="bg-neutral-50 dark:bg-neutral-900 text-gray-900 dark:text-gray-100">
      <Header />
      <Hero />
      <Moments />
      <Popular metas={metas} authors={authors} />
      <Inside />
      <Levels />
      <Authors authors={authors} />
      <Topics topics={subcategories} />
      <Perks />
      <Closing />
      <ScrollToTop />
    </main>
  );
};
